import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  categoriesService() {
    return this.http.get(environment.url + '/MG/CategoriesInfo',
      { headers: this.headers.set('Authorization', sessionStorage.getItem('t_admin')) }).pipe(retry(1), catchError(this.errorHandl));
  }

  updateCategories(element) {
    return this.http.put<any>(environment.url + '/MG/CategoriesInfo', element, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
